
document.addEventListener('DOMContentLoaded', function() {
    // Function to set the display based on beanstype
    function updateBeanstypeDisplay(beanstype) {
        // Handle the display for each specific type
        if (beanstype === 'cups') {
            document.querySelectorAll('.cup-beans').forEach(function(div) {
                div.style.display = 'grid'; 
            });
            document.querySelectorAll('.filter-beans, .default-beans').forEach(function(div) {
                div.style.display = 'none';  
            });
        } else if (beanstype === 'filter') {
            document.querySelectorAll('.filter-beans').forEach(function(div) {
                div.style.display = 'grid';  
            });
            document.querySelectorAll('.cup-beans, .default-beans').forEach(function(div) {
                div.style.display = 'none';  
            });
        } else if (beanstype === 'beans') {
            document.querySelectorAll('.default-beans').forEach(function(div) {
                div.style.display = 'grid';  
            });
            document.querySelectorAll('.cup-beans, .filter-beans').forEach(function(div) {
                div.style.display = 'none';  
            });
        }
    }

    // Function to handle the button click and update localStorage
    function handleQuizOptionClick(answer) {
        let beanstype = null;  // No default, only specific answers will set this

        if (answer === 'filter') {
            beanstype = 'filter';
        } else if (answer === 'cups') {
            beanstype = 'cups';
        } else if (answer === 'beans') {
            beanstype = 'beans';
        }

        // If beanstype is set, update localStorage and display
        if (beanstype) {
            localStorage.setItem('beanstype', beanstype);
            updateBeanstypeDisplay(beanstype);
        }
    }

    // Add click event listeners to the quiz option buttons
    document.querySelectorAll('.quiz-option').forEach(function(option) {
        option.addEventListener('click', function() {
            var answer = this.getAttribute('data-answer');
            console.log("beans type", answer);
            handleQuizOptionClick(answer);
        });
    });

    // On page load, check localStorage and set the correct display
    var storedBeanstype = localStorage.getItem('beanstype');  // No default fallback
    if (storedBeanstype) {
        updateBeanstypeDisplay(storedBeanstype);
    }
});
